import {CustomPage} from '@common/admin/custom-pages/custom-page';
import {useEffect, useRef} from 'react';
import {highlightAllCode} from '@common/text-editor/highlight/highlight-code';

interface CustomPageBodyProps {
  page: CustomPage;
}
export function CustomPageBody({page}: CustomPageBodyProps) {
  const bodyRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (bodyRef.current) {
      highlightAllCode(bodyRef.current);
    }
  }, []);

  // Check if the body content is already a complete HTML document
  const isCompleteHtml = /<html[^>]*>/i.test(page.body) || 
                        /<body[^>]*>/i.test(page.body) ||
                        /<head[^>]*>/i.test(page.body);

  // If it's complete HTML, render it without additional wrapping
  if (isCompleteHtml) {
    return (
      <div
        ref={bodyRef}
        dangerouslySetInnerHTML={{__html: page.body}}
      />
    );
  }

  // If it's partial content, wrap it in the standard layout
  return (
    <div className="px-16 md:px-24">
      <div className="custom-page-body prose mx-auto my-50 dark:prose-invert">
        <h1>{page.title}</h1>
        <div
          ref={bodyRef}
          className="whitespace-pre-wrap break-words"
          dangerouslySetInnerHTML={{__html: page.body}}
        />
      </div>
    </div>
  );
}
